var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KBreadcrumbs',{attrs:{"showSingleItem":"","items":[{ text: 'Home', link: null }]}})
}
var staticRenderFns = []

export { render, staticRenderFns }